import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M8 19h-3a2 2 0 0 1 -2 -2v-10a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v11a1 1 0 0 1 -1 1","key":"svg-0"}],["path",{"d":"M12 14a2 2 0 1 0 4.001 -.001a2 2 0 0 0 -4.001 .001","key":"svg-1"}],["path",{"d":"M17 19a2 2 0 0 0 -2 -2h-2a2 2 0 0 0 -2 2","key":"svg-2"}]]

const IconChalkboardTeacher = createReactComponent('outline', 'chalkboard-teacher', 'ChalkboardTeacher', __iconNode);

export default IconChalkboardTeacher;